export const siteConfig = {
  name: "CricketSync",
  url: "https://cricket-sync.vercel.app/",
  description: "My ramblings on all things web dev.",
  author: "Utsav Khatri",
  links: {
    twitter: "https://twitter.com/UtsavKhatri8",
    github: "https://github.com/Utsav173",
  },
  keywords: [
    "web development",
    "nextjs blog",
    "tech blog",
    "react blog platform",
    "developer blog",
    "programming tutorials",
    "software engineering",
    "coding tips",
    "web development tutorials",
    "frontend development",
    "cricket 07 guides",
    "gaming tutorials",
    "EA sports games",
    "cricket gaming",
    "game modifications",
    "offline AI",
    "chrome AI features",
    "browser AI",
    "web AI integration",
    "Gemini Nano",
    "MDX blog",
    "technical writing",
    "developer resources",
    "code tutorials",
    "tech guides",
  ],
};

export type SiteConfig = typeof siteConfig;
